import styled from 'helpers/styles';
import {css} from 'styled-components';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Typography from '@mui/material/Typography';
import utils from 'helpers/utils';

const StyledTypography = styled(Typography)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--typography-color': props.theme.property(`palette.${props.$color}`)?.main ?? props.theme.property(`palette.${props.$color}`),
      '--typography-disabled-color': props.theme.property('palette.action.disabled'),
      '--typography-line-height': props.$lineHeight ? props.theme.lineHeight(props.$lineHeight) : null,
      '--typography-line-height-font': utils.isDefined(props.$lineHeight) ? props.theme.lineHeight(`${props.$lineHeight}f`) : null
    };

    return utils.styleProps(attr, vars);
  })`
  
  &.Typography-span {
    &.Skeleton {
      display: inline-block;
    }
  }
  &.Typography-p {
    margin-top: ${props => props.theme.spacing(2)};
    margin-bottom: ${props => props.theme.spacing(2)};
  }

  ${props => props.$lineHeight ? css`
    line-height: ${props.$css.$var('--typography-line-height', false)};
  ` : null}
  
  ${props => props.variant ? css`
    ${props.theme.font2Css(props.variant)};

    ${props => utils.isDefined(props.$lineHeight) ? css`
      line-height: ${props.$css.$var('--typography-line-height-font', false)};
    ` : null}
  ` : null}
  
  
  &.Typography-color {
    color: ${props => props.$css.$var('--typography-color')};
  }
  &.Typography-disabled {
    color: ${props => props.$css.$var('--typography-disabled-color')};
  }

  &.Typography-copyText {
    cursor: pointer
  }

  &.Typography-nowrap {
    white-space: nowrap;
  }
  
  ${ComponentStyles}
`;

StyledTypography.propTypes = {
  theme: PropTypes.object
};

export default StyledTypography;
